module.exports = __webpack_public_path__ + "static/media/hapticGoRoundImg3.d0320b04.jpg";